<template>
  <div data-view>
    <room-detail
      :title="roomDetail.fullname"
      :type="roomDetail.type"
      :description="roomDetail.description"
      :size="roomDetail.size"
      :unit="roomDetail.unit"
      :imageUrl="roomDetail.imageUrl"
      :highlights="roomDetail.highlights"
    />
    <gallery-item
      data-aos="fade-up"
      gallery-id="gallery-neera-green-space"
      :images="roomDetail.roomImages"
    />
    <photo-grid data-aos="fade-up" :photos="roomDetail.galleries" />
    <room-facilities
      data-aos="fade-up"
      :facilities="roomDetail.roomFacilities.facilities"
      :imageUrl="roomDetail.roomFacilities.imageUrl"
    />
    <other-rooms exclude-path="/rooms/pond" />
  </div>
</template>

<script>
import OtherRooms from "@/components/OtherRooms.vue";
import RoomDetail from "./components/RoomDetail.vue";
import PhotoGrid from "@/components/PhotoGrid.vue";
import GalleryItem from "@/components/GalleryItem.vue";
import RoomFacilities from "./components/RoomFacilities.vue";
import AOS from "aos";
import config from "@/config";

export default {
  components: {
    OtherRooms,
    RoomDetail,
    PhotoGrid,
    RoomFacilities,
    GalleryItem,
  },
  name: "Pond Room",
  created() {
    const title = "better living in ‘pond’";
    const description = "this 34 sqm room on the 3rd floor is perfect for a mindful getaway with a comfortable king-size bed overviewing the river and get access to your own private balcony and an ensuite bathroom."
    // const titleEl = document.querySelector("head title");
    const mTitleEl = document.querySelector('head meta[name="title"]');
    const descEl = document.querySelector('head meta[name="description"]');
    const twTitleEl = document.querySelector('head meta[name="twitter:title"]');
    const twDescEl = document.querySelector(
      'head meta[name="twitter:description"]'
    );
    const ogTitleEl = document.querySelector('head meta[property="og:title"]');
    const ogDescEl = document.querySelector('head meta[property="og:description"]');
    // titleEl.textContent = title;
    mTitleEl.setAttribute("content", title);
    twTitleEl.setAttribute("content", title);
    ogTitleEl.setAttribute("content", title);
    descEl.setAttribute("content", description);
    twDescEl.setAttribute("content", description);
    ogDescEl.setAttribute("content", description);
  },
  mounted() {
    AOS.init({
      once: true,
      duration: 2000,
    });
  },
  computed: {
    roomDetail() {
      for (var key in config.rooms) {
        console.log(config.rooms[key]); //alerts key's value
        if (key == "pond") return config.rooms[key];
      }
      return {};
    },
  },
};
</script>

<style scoped>
.booking_button {
  color: #994e2e;
  border: 1px solid #994e2e;
  border-radius: 10px;
}
</style>
